import React, { useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Form, Input, message } from 'antd'
import { Lock, ArrowRight, BarChart3, Shield } from 'lucide-react'
import axios from 'axios'
import { logo } from '../../assets/index'
import { AUTH } from '../../utils/apis'
import { allPaths } from '../../utils/constants'
import '../Login/LoginPage.css'

const ResetPassword = () => {
    const { token } = useParams()
    const history = useHistory()
    const [loading, setLoading] = useState(false)

    const onFinish = async (values) => {
        try {
            setLoading(true)
            await axios.post(`${AUTH.RESET_PASSWORD}/${token}`, {
                newPassword: values?.password
            })
            message.success('Password reset successful!')
            history.push(allPaths.LOGIN)
        } catch (err) {
            message.error(err?.response?.data?.message || 'Something went wrong')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="login-container">
            {/* Left Section */}
            <div className="left-section">
                <div className="left-content">
                    <div className="logo-section">
                        <div className="logo-icon">
                            <span className="logo-letter">E</span>
                        </div>
                        <div className="logo-text">
                            <div className="company-name">ELMEC</div>
                            <div className="company-subtitle">ELETTRONICA</div>
                        </div>
                    </div>

                    <div className="welcome-section">
                        <h1 className="main-heading">
                            Reset your  <br />
                            <span className="dashboard-text"> Password</span>
                        </h1>
                        <p className="description">
                            Create a strong password to keep your <br />
                            account secure and protected.
                        </p>
                    </div>

                    <div className="features-section">
                        <div className="feature-card">
                            <div className="feature-icon analytics-icon">
                                <BarChart3 size={24} />
                            </div>
                            <div className="feature-content">
                                <h3 className="feature-title">Analytics</h3>
                                <p className="feature-description">Real-time insights and<br />reporting</p>
                            </div>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon security-icon">
                                <Shield size={24} />
                            </div>
                            <div className="feature-content">
                                <h3 className="feature-title">Security</h3>
                                <p className="feature-description">Enterprise-grade protection</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Section */}
            <div className="right-section">
                <div className="login-form-container">
                    <div className="form-header">
                        <h2 className="form-title">Create new password</h2>
                        <p className="form-subtitle">
                            Your new password must be different from <br />
                            previously used passwords.
                        </p>
                    </div>

                    <Form onFinish={onFinish} layout="vertical" className="login-form">
                        <Form.Item
                            name="password"
                            label="New Password"
                            rules={[
                                { required: true, message: 'Please input your new password!' },
                                { min: 8, message: 'Password must be at least 8 characters!' }
                            ]}
                            className="input-group"
                        >
                            <div className="input-wrapper">
                                <Lock className="input-icon" size={20} />
                                <Input.Password placeholder="••••••••" className="form-input" />
                            </div>
                        </Form.Item>

                        <Form.Item
                            name="confirmPassword"
                            label="Confirm Password"
                            dependencies={['password']}
                            rules={[
                                { required: true, message: 'Please confirm your password!' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve()
                                        }
                                        return Promise.reject('Passwords do not match!')
                                    },
                                }),
                            ]}
                            className="input-group"
                        >
                            <div className="input-wrapper">
                                <Lock className="input-icon" size={20} />
                                <Input.Password placeholder="••••••••" className="form-input" />
                            </div>
                        </Form.Item>

                        <Form.Item>
                            <button
                                type="submit"
                                disabled={loading}
                                className={`submit-button ${loading ? 'loading' : ''}`}
                            >
                                {loading ? 'Resetting...' : (
                                    <>
                                        Reset Password
                                        <ArrowRight size={20} />
                                    </>
                                )}
                            </button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword
